export const MODAL_ELEMENT_ATTRS = {
  id: 'free-product-guest-checkout-modal',
  width: '400px',
  maxWidth: '400px',
  height: '400px',
  backgroundColor: '#FFFFFF',
  modalOverlayBackgroundColor: '#00000030',
  padding: '24px',
  borderRadius: '8px',
  borderWidth: '1px',
  borderColor: '#E5E7EB',
  borderStyle: 'solid',
  orientation: 'horizontal' as const,
  gap: '16px',
  modalCloseButtonColor: '#030712',
  modalCloseButtonPlacementTop: '24px',
  modalCloseButtonPlacementRight: '24px',
};
